import appConfig from 'app-config';

/*
 * https://docs.google.com/spreadsheets/d/1vcVIk6EWAPdlOZRPpsBVxxJZD1RjrvRxFqbEjlTUfDc/edit?gid=916251524#gid=916251524
 */
type EventName = 'signup' | 'login' | 'purchase' | 'match_10min' | 'match_20min' | 'match_30min';

type EventParams = {
  purchase: {
    eventRevenue: number;
    eventRevenueCurrency: string;
  };
};

type EventPayload<T extends keyof EventParams> = EventParams[T];

export const pushAppsflyerEvent = <T extends EventName>(
  eventName: T,
  ...restArgs: T extends keyof EventParams ? [EventPayload<T>] : []
) => {
  /*
   * SDK Script는 AppsflyerPBAThirdPartyScript.tsx에서 로드됨
   */
  if (typeof window.AF === 'undefined') {
    return;
  }

  const [eventParams] = restArgs;

  window.AF('pba', 'event', {
    eventType: 'EVENT',
    eventName,
    eventValue: {
      app_type: appConfig.serviceCode,
      environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    },
    ...eventParams,
  });
};

export const setAppsflyerCustomerUserId = (userId: string) => {
  if (typeof window.AF === 'undefined') {
    return;
  }

  window.AF('pba', 'setCustomerUserId', userId);
};
